import React from 'react'
import { Typography, withStyles, TextField, Button } from '@material-ui/core'
import styles from './styles'
import CustomizedSwitch from 'src/components/customized-switch'
import CoreAutoComplete from 'src/components/core/core-auto-complete'
import { CoreButton } from 'src/components/core'
import { useDispatch, useSelector } from 'react-redux'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import GeneralSettings from 'src/components/user-access'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import AccessRule from 'src/model/access-rule'
import { track } from '@amplitude/analytics-browser'
import { editorEnum } from 'src/model/editor/editorEnum'

const HeaderSettingsPricing = ({
  classes,
  priceTagActive,
  onThemeSettingsChange,
  showPriceTag,
  accessRule,
  header,
  collectionEditCard,
}) => {
  const landingPageDataCollection = useSelector(
    state => state.collection.landingPageSettings || '',
  )
  const landingPageSection = landingPageDataCollection?.sections?.find(
    x => x.type === editorEnum.headerType,
  )
  const collectionSettings = useSelector(state => state.collection.collection)

  const effectivePriceTagActive = header
    ? landingPageSection?.content?.priceTagActive
    : priceTagActive

  const dispatch = useDispatch()

  const handleCurrencyChange = (event, newValue) => {
    onThemeSettingsChange('selectedCurrency', newValue)
  }

  const handlePriceChange = event => {
    const value = event.target.value
    onThemeSettingsChange('priceValue', value)
  }
  const handlePriceTagChange = (event, checked) => {
    track('Show_Price_Tag_Toggled', {
      status: checked ? 'on' : 'off',
    })
    onThemeSettingsChange('priceTagActive', checked)
  }
  const generalSettings = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          maxHeight: '600px',
          maxWidth: '880px',
          buttons: [],
          title: 'Learner`s authentication',
          component: (
            <GeneralSettings
              modal={true}
              collectionId={
                collectionEditCard
                  ? collectionEditCard.id
                  : collectionSettings.id
              }
              collectionEditCard={collectionEditCard}
            />
          ),
        }),
      ),
    )
  }

  return (
    <>
      <div className={classes.switchContainer}>
        <div className={classes.headerRow}>
          <div className={classes.headerText}>
            <Typography fontSize="14px" fontWeight={400} color="#002E47">
              Pricing Settings
            </Typography>
            <Typography fontSize="12px" fontWeight={400} color="#919EAB">
              This is for display purposes only. If paid access isn't enabled,
              "Free" will appear on your landing page.
            </Typography>
          </div>
          <CoreButton
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => {
              generalSettings()
            }}
          >
            Set Display Price
          </CoreButton>
        </div>
        {showPriceTag !== false && (
          <div className={classes.switch}>
            <CustomizedSwitch
              onChange={handlePriceTagChange}
              checked={effectivePriceTagActive}
            />
            <Typography fontSize="14px" fontWeight={400} color="#002E47">
              Show Price Tag
            </Typography>
          </div>
        )}
      </div>
    </>
  )
}

export default withStyles(styles)(HeaderSettingsPricing)
